//
//
//
//
//
//
//

export default {
  methods: {
    handleExit() {
      this.$router.push('/salir')
    },
  },
}
